/* eslint-disable */

import request from '@/utils/request'

export function getListGeneralParameter(query) {
  return request({
    url: '/config-service/v1/general-param-config',
    method: 'get',
    params: query
  })
}

export function updateGuestTemplate(query) {
  return request({
    url: '/config-service/v1/general-param-config',
    method: 'put',
     data: query
  })
}
